<template>
  <div>
    <el-card class="detail-card">
      <el-row class="detail-title">
        <span>您的发票申请分&nbsp;
          <span class="pxy-color"> {{1}}</span>
          &nbsp;张发票开具，开票总额&nbsp;￥
          <span class="pxy-color">{{invoiceData.invoiceAmount}}</span>
        </span>
      </el-row>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="发票性质">{{invoiceSendTypeObj[invoiceData.invoiceSendType]}}</el-descriptions-item>
        <el-descriptions-item label="发票状态">{{statusObj[invoiceData.status]}}</el-descriptions-item>
        <el-descriptions-item v-if="invoiceData.status===9" label="驳回理由">{{invoiceData.approvalNote}}
        </el-descriptions-item>
        <el-descriptions-item label="发票类型">{{invoiceType[invoiceData.invoiceType]}}</el-descriptions-item>
        <el-descriptions-item label="发票抬头">{{invoiceData.title}}</el-descriptions-item>
        <el-descriptions-item label="税号">{{typeof invoiceData.ofcInvoiceInfoDto != "undefined" ? invoiceData.ofcInvoiceInfoDto.creditCode : ''}}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{invoiceData.createDateSelf}}</el-descriptions-item>
        <el-descriptions-item label="发票编号">{{invoiceData.id}}</el-descriptions-item>
        <template v-if="invoiceData.invoiceSendType===1">
          <el-descriptions-item label="邮箱">{{invoiceData.email}}</el-descriptions-item>
        </template>
        <template v-if="invoiceData.invoiceSendType===0">
          <el-descriptions-item label="收件人">{{invoiceData.name}}</el-descriptions-item>
          <el-descriptions-item label="收取地址">{{invoiceData.address}}</el-descriptions-item>
          <!-- <el-descriptions-item label="收取邮编">{{}}</el-descriptions-item> -->
          <el-descriptions-item label="联系电话">{{invoiceData.mobile}}</el-descriptions-item>
          <el-descriptions-item label="物流公司">{{invoiceData.logisticsCompany}}</el-descriptions-item>
          <el-descriptions-item label="物流单号">{{invoiceData.logisticsOrderNo}}</el-descriptions-item>
        </template>
        <el-descriptions-item label="备注" :span="4">{{invoiceData.note}}</el-descriptions-item>
        s
      </el-descriptions>
      <el-table :data="invoiceTableData" style="margin-top: 20px">
        <template v-for="(item,index) in tableColumns">
          <el-table-column :prop="item.key" :label="item.label" :min-width="item.width" :key="index"></el-table-column>
        </template>
      </el-table>
      <PageComponent ref="pageInfo"></PageComponent>
    </el-card>
  </div>
</template>
<script>
  import {formatDateTime} from "@/utils/util.js"
  import PageComponent from "@/components/pageInfo/PageComponent";

  let columns = [
    {key: 'orderId', label: '订单编号', width: '160'},
    {key: 'prodName', label: '产品名称', width: '100'},
    {key: 'startDateSelf', label: '订单支付时间', width: '100'},
    {key: 'cashPayAmount', label: '金额', width: '100'},
    {key: 'endDateSelf', label: '成功时间', width: '100'},
  ]
  export default {
    components: {PageComponent},
    data() {
      return {
        invoiceTableData: [],
        tableColumns: columns,
        // 发票状态
        statusObj: {
          0: '开票中',
          1: '已开票',
          5: '撤销',
          9: '驳回'
        },
        // 发票类型
        invoiceType: ['增值税普通发票', '增值税专用发票'],
        invoiceMakeType:'1',
        invoiceData: {
          invoiceAmount: '',
          invoiceSendType: '',
          creditCode:'',
          status: '',
          invoiceType: '',
          title: '',
          createDateSelf: '',
          id: '',
          address: '',
          logisticsCompany: '',
          logisticsOrderNo: '',
          userId:'',
          loginId:'',
          company:'',
          note: '',
        },
        invoiceSendTypeObj: ['纸质', '电子']
      }
    },
    computed: {
      invoiceTitle() {
        return this.invoiceData.title
      },
      user() {
        return this.$store.state.user;
      },
    },
    mounted() {
      this.$refs.pageInfo.initPagenator(this.getList, 10);
      this.getData();
    },
    methods: {

      // 获取发票信息
      getData() {
        let params = {
          id: this.$route.query.invoiceLogId
        }
        let url = "/ofc/invoiceLog/search";
        if (this.user.role == '30'){
          url = '/dev/system/ofc/invoiceLog/search';
        }
        this.getRequest(url, params).then(res => {
          if (res.status == 200) {
            if (res.data.code == 1000) {
              let list = res.data.result.records.map(item => {
                return Object.assign(item, {
                  createDateSelf: this.formatDateTime(item.createDate),
                  invoiceTypeSelf: item.invoiceType === 0 ? '增值税普通发票' : (item.invoiceType === 1 ? '增值税专用发票' : ''),
                  invoiceSendTypeSelf: item.invoiceSendType === 0 ? '纸质' : (item.invoiceSendType === 1 ? '电子' : ''),
                  statusSelf: this.statusObj[item.status],
                })
              })
              this.invoiceData = list[0];
              console.log(this.invoiceData)
              this.getInvoiceData(this.invoiceData.invoiceInfoId);
              this.getList();
            }
          }
        })
      },
      getInvoiceData(id) {
        let params = {
          id: id
        }
        if (this.user.role == '30'){
          this.getRequest('/dev/system/ofc/invoiceInfo/search', params).then(res => {
            // console.log(res,'invoicedata')
            if (res.status == 200) {
              if (res.data.code == 1000) {
                this.$set(this.invoiceData, 'title', res.data.result.records[0].title)
                this.$set(this.invoiceData, 'creditCode', res.data.result.records[0].creditCode)
              }
            }
          })
        }else {
          this.getRequest('/ofc/getPersonalInvoiceInfo', params).then(res => {
            // console.log(res,'invoicedata')
            if (res.status == 200) {
              if (res.data.code == 1000) {
                this.$set(this.invoiceData, 'title', res.data.result.title)
              }
            }
          })
        }

      },
      async getList() {
        await this.getInvoiceMakeType().then(resp => {
          let invoiceMakeType = resp;
          let params = {
            invoiceLogId: this.$route.query.invoiceLogId,
            page: this.$refs.pageInfo.currentPage,
            pageSize: 10,
            userId: this.invoiceData.userId
          }
          if(invoiceMakeType == '1'){
            let url = "/ofc/expenseAggregate/getExpenseList";
            if(this.user.role == '30'){
              url = "/dev/system/ofc/expenseAggregate/getExpenseList"
            }
            this.getRequest(url, params).then(res => {
              if (res.status == 200) {
                let data = res.data;
                if (data.code == 1000) {
                  // this.invoiceData = data.result.records[0];
                  if(data.result != null){
                    this.invoiceTableData = data.result.records.map(item => {
                      return Object.assign(item, {
                        startDateSelf: formatDateTime(item.startDate),
                        endDateSelf: formatDateTime(item.endDate)
                      })
                    })
                    this.$refs.pageInfo.outputPagenator(res.data.result.total);
                  }

                } else {
                  this.$message.error(data.message)
                }
              }
            })
          }else {
            this.tableColumns = [
              {key: 'prodType', label: '支付方式', width: '100'},
              {key: 'amount', label: '金额', width: '100'},
              {key: 'createDateSelf', label: '订单支付时间', width: '100'},
            ]
            let url = "/ofc/payLog/search";
            if(this.user.role == '30'){
              url = "/ofcRechargeLog/list"
            }
            this.getRequest(url, params).then(res => {
              console.log(res)
              if (res.status == 200) {
                let data = res.data;
                if (data.code == 1000) {
                  // this.invoiceData = data.result.records[0];
                  this.invoiceTableData = data.result.records.map(item => {
                    return Object.assign(item, {
                      amount: item.amount/100,
                      prodType : item.payType == '11' ? '微信':'其他',
                      createDateSelf: formatDateTime(item.createDate),
                    })
                  })
                  this.$refs.pageInfo.outputPagenator(res.data.result.total);
                } else {
                  this.$message.error(data.message)
                }
              }
            })
          }

        });

      },
      // 获取开发票类型：预开发票和后开发票
      getInvoiceMakeType() {
        if (this.user.role == '30') {
          return this.getRequest('/dev/system/ofc/invoiceMakeType/search', {userId:this.$route.query.userId}).then(resp => {
            if (resp.status == 200) {
              if (resp.data.code == 1000) {
                return resp.data.result.records[0].type;
              } else {
                Message.error(resp.data.message);
              }
            } else {
              console.error("error")
            }
          })
        }else {
          return this.getRequest('/ofc/getPersonalInvoiceMakeType', {}).then(resp => {
            if (resp.status == 200) {
              if (resp.data.code == 1000) {
                console.log(resp.data)
                return resp.data.result.type;
              } else {
                Message.error(resp.data.message);
              }
            } else {
              console.error("error")
            }
          })
        }
      },
    }
  }
</script>
<style lang='scss' scoped>
  .detail-card {
    margin-top: 15px;

    .detail-title {
      border: 1px solid #EBEEF5;
      border-bottom: none;
      padding: 12px 10px;
    }
  }
</style>
